import type { Entry } from "../types";

export const standardsMessages = {
  invite: { ko: "구성원 초대", en: "Invite Member" },
  email: { ko: "이메일", en: "Email" },
  role: { ko: "역할", en: "Role" },
  userLevel: { ko: "사용자 권한", en: "User level" },
  addPolicy: { ko: "정책 추가", en: "Add Policy" },
  addVersion: { ko: "새 버전 추가", en: "Add Version" },
  addRule: { ko: "규칙 추가", en: "Add Rule" },
  activate: { ko: "활성화", en: "Activate" },
  active: { ko: "활성", en: "Active" },
  retire: { ko: "비활성화", en: "Retire" },
  version: { ko: "버전", en: "Version" },
  category: { ko: "분류", en: "Category" },
  description: { ko: "설명", en: "Description" },
  source: { ko: "출처 분류", en: "Source" },
  authority: { ko: "발행 기관", en: "Authority" },
  effectiveDate: { ko: "시행일", en: "Effective Date" },
  reviewDeadline: { ko: "검토 기한", en: "Review Deadline" },
  processing: { ko: "처리 상태", en: "Processing" },
  approval: { ko: "승인 상태", en: "Approval" },
  policyDocumentHelp: {
    ko: "등록된 문서를 확인하고 다른 버전과 나란히 비교할 수 있습니다.",
    en: "Inspect the registered document and compare it side by side with another version.",
  },
  backToPolicies: { ko: "정책 목록으로", en: "Back to policies" },
  download: { ko: "다운로드", en: "Download" },
  viewVersion: { ko: "확인할 버전", en: "View version" },
  activeVersion: { ko: "활성 버전", en: "Active version" },
  documentChanges: { ko: "버전 간 변경 항목", en: "Changes between versions" },
  documentNoChanges: {
    ko: "두 버전의 문서 정보가 동일합니다. 문서 내용은 아래에서 직접 비교하세요.",
    en: "Both versions share the same document details. Compare the document contents below.",
  },
  documentComparisonNote: {
    ko: "문서 원본을 나란히 표시합니다. 바뀐 문구는 '본문 비교'에서 확인하세요.",
    en: "The original documents are shown side by side. Use Text comparison to see the changed wording.",
  },
  documentPreviewFailed: {
    ko: "문서 미리보기를 불러오지 못했습니다. 원본을 다운로드해 확인하거나 잠시 후 다시 시도하세요.",
    en: "The document preview could not be loaded. Download the original or try again shortly.",
  },
  documentPreviewChecking: { ko: "문서 미리보기를 확인하는 중입니다…", en: "Checking the document preview…" },
  documentConversionNotice: {
    ko: "PDF 파일로 올리는 것을 권장합니다. 한글, Word 문서는 사용 중인 프로그램에서 'PDF로 저장'한 뒤 올리면 서식이 그대로 유지되어 미리보기와 버전 비교가 가장 정확합니다. PDF가 아닌 파일도 올릴 수 있지만 자동 변환 과정에서 서식이 달라지거나 변환에 실패할 수 있습니다.",
    en: "We recommend uploading PDF files. Save Hangul or Word documents as PDF in the app you use, then upload them — the layout stays intact, so preview and version comparison are most accurate. Other files are accepted, but automatic conversion may change the layout or fail.",
  },
  documentConversionProcessing: {
    ko: "비교용 PDF를 생성하는 중입니다. 완료되면 미리보기가 자동으로 표시됩니다.",
    en: "Creating the comparison PDF. The preview will appear automatically when it is ready.",
  },
  documentConversionFailed: {
    ko: "문서는 정상적으로 등록되었지만 미리보기와 버전 비교에 쓰는 PDF를 만들지 못했습니다. 원본 다운로드와 정책 사용은 계속 가능합니다. 사용 중인 문서 프로그램(한글, Word 등)에서 PDF로 저장한 뒤 새 버전으로 올려 주세요.",
    en: "The document was registered, but the PDF used for preview and version comparison could not be created. You can still download the original and use the policy. Save the document as PDF in the app you use (Hangul, Word, etc.) and upload it as a new version.",
  },
  documentConversionRetry: { ko: "PDF 변환 다시 시도", en: "Retry PDF conversion" },
  documentConversionRetrying: { ko: "PDF를 다시 변환하는 중…", en: "Retrying PDF conversion…" },
  documentConversionRegisteredWithFailure: {
    ko: "정책은 등록되었지만 PDF 변환에 실패해 미리보기와 버전 비교를 사용할 수 없습니다. 문서 프로그램에서 PDF로 저장한 파일을 새 버전으로 올려 주세요.",
    en: "The policy was registered, but PDF conversion failed, so preview and version comparison are unavailable. Save the document as PDF in its app and upload it as a new version.",
  },
  documentConversionUnavailable: {
    ko: "지금은 이 형식의 문서를 자동으로 PDF로 바꿀 수 없습니다. PDF로 저장한 파일을 올려 주세요.",
    en: "This file type can't be converted to PDF automatically right now. Please upload a file saved as PDF.",
  },
  documentConversionTimeout: {
    ko: "문서가 커서 PDF 변환이 제시간에 끝나지 않았습니다. 문서 프로그램에서 PDF로 저장해 올리면 바로 사용할 수 있습니다.",
    en: "Conversion took too long for this document. Save it as PDF in its app and upload that file instead.",
  },
  documentConversionInvalidOutput: {
    ko: "문서를 PDF로 제대로 바꾸지 못했습니다. 파일이 손상되었거나 암호가 걸려 있는지 확인한 뒤, 문서 프로그램에서 PDF로 저장해 올려 주세요.",
    en: "The document could not be converted to PDF correctly. Check that the file isn't damaged or password-protected, then save it as PDF in its app and upload that.",
  },
  documentConversionOutputTooLarge: {
    ko: "변환된 PDF가 허용 크기를 넘었습니다. 문서 속 이미지 크기를 줄이거나, PDF로 저장할 때 용량을 줄이는 옵션을 선택해 올려 주세요.",
    en: "The converted PDF is over the size limit. Shrink the images in the document, or choose a smaller-file option when saving as PDF, and upload it.",
  },
  documentConversionUploadFailed: {
    ko: "PDF 변환은 완료됐지만 저장하지 못했습니다. 잠시 후 다시 시도하세요.",
    en: "The PDF was created but could not be saved. Try again shortly.",
  },
  documentConversionSourceUnavailable: {
    ko: "보관된 원본 파일을 불러오지 못해 PDF를 만들지 못했습니다. 잠시 후 다시 시도하거나, PDF로 저장한 파일을 새 버전으로 올려 주세요.",
    en: "The stored original could not be loaded, so the PDF wasn't created. Try again shortly, or upload a file saved as PDF as a new version.",
  },
  documentConversionGenericFailure: {
    ko: "문서를 PDF로 바꾸지 못했습니다. 문서 프로그램에서 PDF로 저장한 파일을 올려 주세요.",
    en: "The document could not be converted to PDF. Save it as PDF in its app and upload that file.",
  },
  documentNormalizedIndexFailed: {
    ko: "비교용 PDF의 VaultSage 색인에 실패했습니다. 원본을 사용한 정책 운영은 계속되며, PDF 색인을 다시 시도할 수 있습니다.",
    en: "VaultSage could not index the comparison PDF. Policy operation continues with the original, and you can retry the PDF index.",
  },
  documentMissing: { ko: "이 버전에는 첨부된 문서가 없습니다.", en: "This version has no attached document." },
  documentProcessing: {
    ko: "문서를 처리하는 중입니다. 처리가 끝나면 미리보기를 사용할 수 있습니다.",
    en: "The document is still being processed. Preview becomes available once it finishes.",
  },
  documentUnavailable: {
    ko: "문서 색인에 실패했습니다. 미리보기는 가능하지만, 이 버전은 검토에 사용할 수 없습니다. 색인을 다시 시도하거나 새 버전을 등록하세요.",
    en: "Indexing failed. Preview is still available, but this version cannot be used in reviews. Retry indexing, or upload a new version.",
  },
  documentRetryIndexing: { ko: "색인 다시 시도", en: "Retry indexing" },
  documentRetryingIndexing: { ko: "다시 시도하는 중…", en: "Retrying…" },
  documentRetryQueued: {
    ko: "색인을 다시 요청했습니다. 처리에는 몇 분이 걸릴 수 있습니다.",
    en: "Indexing has been requested again. This can take a few minutes.",
  },
  documentRetryRecovered: {
    ko: "문서가 이미 색인되어 있었습니다. 이제 검토에 사용할 수 있습니다.",
    en: "The document was already indexed. It can now be used in reviews.",
  },
  documentDiagnostics: { ko: "진단 정보", en: "Diagnostics" },
  documentDiagnosticsReason: { ko: "업스트림 상태", en: "Upstream status" },
  documentDiagnosticsFileId: { ko: "VaultSage 파일 ID", en: "VaultSage file ID" },
  documentDiagnosticsCheckedAt: { ko: "마지막 확인", en: "Last checked" },
  documentDiagnosticsNeverChecked: { ko: "아직 확인하지 않음", en: "Not checked yet" },
  policyVersionNotFound: { ko: "정책 버전을 찾을 수 없습니다.", en: "Policy version not found." },
  documentView: { ko: "문서 보기", en: "Documents" },
  textCompareView: { ko: "본문 비교", en: "Text comparison" },
  textCompareFromVersion: { ko: "이전 버전 v{version}", en: "Previous version v{version}" },
  textCompareToVersion: { ko: "현재 버전 v{version}", en: "Current version v{version}" },
  textCompareLoading: {
    ko: "본문을 추출해 비교하는 중입니다. 문서가 길면 시간이 걸릴 수 있습니다.",
    en: "Extracting and comparing the text. A long document can take a while.",
  },
  textCompareRetry: { ko: "본문 비교 다시 시도", en: "Retry text comparison" },
  textCompareSummary: {
    ko: "v{from} 대비 {added}줄 추가, {removed}줄 삭제",
    en: "{added} lines added and {removed} removed compared with v{from}",
  },
  textCompareIdentical: {
    ko: "두 버전의 본문이 동일합니다.",
    en: "The text of both versions is identical.",
  },
  textCompareNoText: {
    ko: "v{version} 문서는 스캔 또는 이미지 기반이라 추출할 본문이 없습니다. 문서 보기나 원본 다운로드로 확인하세요.",
    en: "Version {version} is scanned or image-based and has no extractable text. Check the document view or download the original.",
  },
  textCompareNormalizationFailed: {
    ko: "v{version} 문서의 PDF 변환에 실패하여 본문을 비교할 수 없습니다. 변환을 다시 시도하거나 원본을 다운로드해 확인하세요.",
    en: "Version {version} could not be compared because PDF conversion failed. Retry conversion or download the original.",
  },
  textCompareExtractionFailed: {
    ko: "v{version} 문서에서 본문을 읽는 중 오류가 발생했습니다. 원본 문서가 손상되었거나 암호화되었는지 확인하세요.",
    en: "Text could not be read from version {version}. Check whether the original is damaged or encrypted.",
  },
  textCompareSourceUnavailable: {
    ko: "v{version} 원본 파일을 불러올 수 없습니다. 잠시 후 다시 시도하고 계속되면 관리자에게 문의하세요.",
    en: "The source file for version {version} is unavailable. Retry shortly and contact an administrator if it continues.",
  },
  policyFileTooLarge: { ko: "정책 문서는 25MB 이하여야 합니다.", en: "Policy documents must be 25 MB or smaller." },
  policyFileSignatureMismatch: {
    ko: "파일 확장자와 실제 내용이 일치하지 않습니다. 올바른 파일을 다시 선택하세요.",
    en: "The extension does not match the file contents. Select the correct file and try again.",
  },
  policyFileUnsupported: {
    ko: "지원하지 않는 정책 문서 형식입니다.",
    en: "This policy document format is not supported.",
  },
  textCompareTruncated: {
    ko: "변경이 너무 많아 일부만 표시합니다. 전체 내용은 문서 보기에서 확인하세요.",
    en: "Too many changes to show them all. Use the document view for the full content.",
  },
  textCompareLegend: {
    ko: "초록색은 v{to}에 추가된 줄, 빨간색은 v{from}에서 삭제된 줄입니다.",
    en: "Green lines were added in v{to}; red lines were removed from v{from}.",
  },
  loading: { ko: "불러오는 중...", en: "Loading..." },
  none: { ko: "없음", en: "None" },
  saved: { ko: "저장되었습니다", en: "Saved" },
  configIntro: {
    ko: "조직의 자동 사전 검토 대상과 컴플라이언스 검토 기한을 관리합니다.",
    en: "Manage which targets complete automatically and compliance review targets.",
  },
  autoClearTitle: { ko: "자동 사전 검토 완료", en: "Automatic self-check completion" },
  autoClearHelp: {
    ko: "담당자 검토 없이 완료할 검토 대상을 지정합니다.",
    en: "Choose which reviews may complete without an officer reviewing them.",
  },
  enableAutoClear: { ko: "검증된 PASS 결과 자동 완료", en: "Automatically complete validated PASS results" },
  enableAutoClearWarning: {
    ko: "이 결과는 법적 승인이 아닙니다. 벤치마크와 그림자 모드 결과를 검토한 후 활성화하세요.",
    en: "This is not legal approval. Enable only after reviewing benchmark and shadow-mode results.",
  },
  autoClearTargets: { ko: "자동 완료 대상", en: "Auto-completion targets" },
  autoClearMatrixHint: {
    ko: "채널은 열 머리글에서, 자료 구분은 행 머리글에서 선택합니다.",
    en: "Pick channels in the column headers and categories in the row headers.",
  },
  autoClearMatrixLegend: {
    ko: "✓ 자동 완료 대상 {count}개 조합.",
    en: "✓ marks the {count} combinations that auto-complete.",
  },
  autoClearAllCategoriesRow: { ko: "모든 자료 구분", en: "All material categories" },
  autoClearCellIncluded: { ko: "포함", en: "Included" },
  autoClearCellExcluded: { ko: "제외", en: "Excluded" },
  autoClearParentNote: {
    ko: "구분1을 선택하면 이후 추가되는 하위 구분2도 자동으로 포함됩니다.",
    en: "Selecting a 구분1 also includes sub-categories added under it later.",
  },
  enableAutoReject: {
    ko: "동일 대상에 대해 AI 반려 결과도 자동 완료",
    en: "Also complete AI reject outcomes for the same targets",
  },
  enableAutoRejectWarning: {
    ko: "고위험, 검토 필요 결과가 자동 반려로 완료됩니다. 법적 반려가 아니며, 시각 규칙이 적용된 건은 항상 담당자 검토로 갑니다.",
    en: "HIGH_RISK and REVIEW_REQUIRED results complete as self-check rejected. This is not a legal rejection. Visual-rule reviews always stay in the officer queue.",
  },
  autoClearEmptyChannelsWarning: {
    ko: "자동 완료가 켜져 있지만 채널이 선택되지 않아 어떤 검토도 자동 완료되지 않습니다.",
    en: "Automatic completion is on, but no channels are selected, so nothing will auto-complete.",
  },
  autoClearEmptyCategoriesWarning: {
    ko: "자동 완료가 켜져 있지만 자료 구분이 선택되지 않아 어떤 검토도 자동 완료되지 않습니다.",
    en: "Automatic completion is on, but no categories are selected, so nothing will auto-complete.",
  },
  qualitySampleRate: { ko: "품질 확인 표본 비율", en: "Quality-control sample rate" },
  slaTitle: { ko: "검토 목표 시간", en: "Review target times" },
  slaHelp: {
    ko: "각 유형이 컴플라이언스 대기열에 들어온 뒤 처리할 목표 시간을 시간 단위로 설정합니다.",
    en: "Set target turnaround hours after each review type enters the compliance queue.",
  },
  highRiskSla: { ko: "고위험 (시간)", en: "High risk (hours)" },
  reviewRequiredSla: { ko: "검토 필요 (시간)", en: "Review required (hours)" },
  qualitySampleSla: { ko: "품질 표본 (시간)", en: "Quality sample (hours)" },
  deploymentConfigTitle: { ko: "배포 전용 설정", en: "Deployment-only configuration" },
  deploymentConfigHelp: {
    ko: "보안, 인프라 값은 관리자 화면으로 이동하지 않습니다. 환경 변수와 Secret Manager에서만 관리합니다.",
    en: "Security and infrastructure values remain in environment variables and Secret Manager, not this page.",
  },
} as const satisfies Record<string, Entry>;
